import React, {SyntheticEvent, useEffect, useState} from "react";
import {changeStatus, create, deleteById, getById, update} from "../../services/service-order.service";
import {NavigateFunction, useNavigate, useParams, useSearchParams} from "react-router-dom";
import * as Yup from 'yup';
import {useFormik} from 'formik';
import {Chip as ChipMaterial, Link, TextField} from "@mui/material";
import {GridSaveAltIcon} from "@mui/x-data-grid";
import {ArrowBackIosNew} from "@mui/icons-material";
import showNotification from "../utils/Notify";
import {Box, Breadcrumbs, Button, Grid, Stack, Tab, TabList, TabPanel, Tabs, Typography} from "@mui/joy";
import {Experimental_CssVarsProvider as CssVarsProvider} from "@mui/material/styles";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import DesignServicesIcon from '@mui/icons-material/DesignServices';
import IServiceOrder from "../../types/service-order.type";
import {Autocomplete} from "@mui/lab";
import {DatePicker, LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterMoment} from "@mui/x-date-pickers/AdapterMoment";
import moment, {Moment} from "moment/moment";
import IClient from "../../types/client.type";
import {getActiveClients} from "../../services/client.service";
import WorkContactsList from "./workContact/WorkContactsList";
import AllocatedResourcesList from "./allocatedResource/AllocatedResourcesList";
import BudgetsList from "./budget/BudgetsList";
import WorkScopesList from "./workScope/WorkScopesList";
import IUser from "../../types/user.type";
import ITechnique from "../../types/technique.type";
import {getActiveTechniques} from "../../services/techique.service";
import {getAllActiveByDepartment} from "../../services/user.service";
import IServiceOrderChangeStatus from "../../types/service-order-change-status.type";
import {Department} from "../../types/enumeration/Department";
import {ServiceOrderStatus} from "../../types/enumeration/ServiceOrderStatus";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import {ServiceOrderStatusColors} from "../../types/enumeration/ServiceOrderStatusColors";
import {ServiceOrderStatusNames} from "../../types/enumeration/ServiceOrderStatusNames";
import StatusHistoryModal from "../utils/StatusHistoryModal";
import ConfirmationModal from "../utils/ConfirmationModal";
import SendIcon from "@mui/icons-material/Send";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import AttachmentsList from "./attachments/AttachmentsList";
import {v4 as uuidv4} from 'uuid';
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import IProvider from "../../types/provider.type";
import {getActiveSubcontractors} from "../../services/provider.service";
import EditNoteIcon from '@mui/icons-material/EditNote';
import ServiceOrderEvaluationForm from "./performanceEvaluation/ServiceOrderEvaluationForm";

const ServiceOrderForm = () => {
  let navigate: NavigateFunction = useNavigate();
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const copyFrom: number | null = Number(searchParams.get('copy-from')) || null;
  const [clients, setClients] = useState<Array<IClient>>([]);
  const [users, setUsers] = useState<Array<IUser>>([]);
  const [resources, setResources] = useState<Array<IUser>>([]);
  const [techniques, setTechniques] = useState<Array<ITechnique>>([]);
  const [providers, setProviders] = useState<Array<IProvider>>([]);
  const [confirmationModalOpen, setConfirmationModalOpen] = React.useState(false);
  const [statusHistoryModalOpen, setStatusHistoryModalOpen] = React.useState(false);
  const [confirmationDeleteModalOpen, setConfirmationDeleteModalOpen] = React.useState(false);
  const [selectedTab, setSelectedTab] = useState<number>(0);

  const [selectedNewStatus, setSelectedNewStatus] = React.useState<ServiceOrderStatus | null>(null);
  const [modalTitle, setModalTitle] = React.useState("");
  const [modalMessage, setModalMessage] = React.useState("");

  const onConfirm = (comments?: string) => {
    if (selectedNewStatus) {
      let newStatus: IServiceOrderChangeStatus = {
        status: selectedNewStatus,
        comments: comments ? comments : '',
      };
      changeStatus(serviceOrder.id, newStatus)
        .then((response) => {
          let message = newStatus.status === ServiceOrderStatus.SENT ? "La Orden de Servicio fue Enviada correctamente."
            : newStatus.status === ServiceOrderStatus.TO_FIX ? "La Orden de Servicio fue Enviada a Corregir correctamente."
            : "La Orden de Servicio fue Cerrada correctamente.";
          showNotification({type: 'success', message: message});
          navigate('/service-orders')
        })
        .catch(error => {
          showNotification({type: 'error', message: error.response.data.message});
        });
    }

    setSelectedNewStatus(null);
    setConfirmationModalOpen(false);
  };

  const handleConfirmationModalClose = () => {
    setSelectedNewStatus(null);
    setConfirmationModalOpen(false);
  }

  const handleOpenChangeStatusModal = (status: ServiceOrderStatus) => {
    if (status === ServiceOrderStatus.DEFINE_WORK_SCOPE) {
      setModalTitle("Definir Alcance de Trabajo");
      setModalMessage("Se enviara la Orden de Servicio al Analista Tecnico para definir el Alcance de Trabajo.")
    } else if (status === ServiceOrderStatus.FIX_WORK_SCOPE) {
        setModalTitle("Corregir Alcance de Trabajo");
        setModalMessage("Al confirmar se Enviara la Orden de Servicio al los Recursos asignados para ser corregida")
    } else if (status === ServiceOrderStatus.SENT) {
      setModalTitle("Validar Alcance y Enviar Orden de Servicio");
      setModalMessage("Al confirmar se Enviara la Orden de Servicio al los Recursos asignados.")
    } else if (status === ServiceOrderStatus.TO_FIX) {
      setModalTitle("Corregir Orden de Servicio");
      setModalMessage("Al confirmar se Enviara la Orden de Servicio al los Recursos asignados para ser corregida.")
    } else if (status === ServiceOrderStatus.UNDER_EVALUATION) {
      setModalTitle("Evaluar Desempeño de la Orden Servicio");
      setModalMessage("Al confirmar se pasara a evaluar el desempeño de la Orden Servicio.")
    } else {
      setModalTitle("Cerrar Orden de Servicio");
      setModalMessage("Al confirmar se Cerrara la Orden de Servicio.")
    }
    setSelectedNewStatus(status);
    setConfirmationModalOpen(true);
  };

  const handleStatusHistoryModalOpen = () => {
    setStatusHistoryModalOpen(true);
  }

  const handleStatusHistoryModalClose = () => {
    setStatusHistoryModalOpen(false);
  }

  const initialValues: IServiceOrder = {
    id: null,
    allocatedDays: 0,
    client: null,
    number: "",
    purchaseNumber: "",
    quoteNumber: "",
    start: null,
    workAddress: "",
    status: ServiceOrderStatus.IN_PROGRESS,
    statusHistory: [],
    workScopes: [],
    budgets: [],
    allocatedResources: [],
    workContacts: [],
    attachments: [],
  };

  const [serviceOrder, setServiceOrder] = useState<IServiceOrder>(initialValues);

  const updateServiceOrder = (updatedServiceOrder: IServiceOrder | ((prev: IServiceOrder) => IServiceOrder)) => {
    setServiceOrder(updatedServiceOrder);
    formik.setValues(updatedServiceOrder);

    const newServiceOrder =
      typeof updatedServiceOrder === "function"
        ? updatedServiceOrder(serviceOrder)
        : updatedServiceOrder;

    const workers: IUser[] = newServiceOrder.allocatedResources
      .map(resource => resource.worker)
      .filter((worker): worker is IUser => worker !== null);

    setResources(workers);

    if (id) {
      const serviceOrderToSave = cleanServiceOrder(newServiceOrder);

      update(serviceOrderToSave.id, serviceOrderToSave)
        .then(() => {
          showNotification({
            type: 'success',
            message: 'Orden de Servicio guardada correctamente.',
          });
        })
        .catch(error => {
          showNotification({
            type: 'error',
            message: error.response.data.message,
          });
        });
    }
  };

  const validationSchema = Yup.object({
    client: Yup.object().required('El Cliente es requerido'),
    workAddress: Yup.string().required('La Direccion de Obra es requerido'),
    number: Yup.string().required('El Nro. de Orden de Servicio es requerido'),
    purchaseNumber: Yup.string().required('El Nro. de Orden de Compra es requerido'),
    quoteNumber: Yup.string().required('El Nro. de Cotizacion es requerido'),
    start: Yup.string().required('La Fecha de Inicio es requerido'),
    allocatedDays: Yup.string().required('Las Jornadas Asignadas es requerido'),
  });

  function isUUID(value: any): boolean {
    return typeof value === "string" && /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(value);
  }

  function cleanServiceOrder(serviceOrder: IServiceOrder): IServiceOrder {
    return {
      ...serviceOrder,
      id: isUUID(serviceOrder.id) ? undefined : serviceOrder.id,
      workScopes: serviceOrder.workScopes.map(ws => ({
        ...ws,
        id: isUUID(ws.id) ? undefined : ws.id,
      })),
      workContacts: serviceOrder.workContacts.map(contact => ({
        ...contact,
        id: isUUID(contact.id) ? undefined : contact.id,
      })),
      allocatedResources: serviceOrder.allocatedResources.map(resource => ({
        ...resource,
        id: isUUID(resource.id) ? undefined : resource.id,
      })),
      budgets: serviceOrder.budgets.map(budget => ({
        ...budget,
        id: isUUID(budget.id) ? undefined : budget.id,
      }))
    };
  }

  const onSubmit = (serviceOrder: IServiceOrder) => {
    serviceOrder = cleanServiceOrder(serviceOrder);
    if (serviceOrder.id) {
      update(serviceOrder.id, serviceOrder)
        .then(() => {
          showNotification({type: 'success', message: 'Orden de Servicio actualizada correctamente.'});
          fetchServiceOrder();
        })
        .catch(error => {
          showNotification({type: 'error', message: error.response.data.message});
        });
    } else {
      create(serviceOrder)
        .then((response) => {
          showNotification({type: 'success', message: 'Orden de Servicio creada correctamente.'});
          goBack();
        })
        .catch(error => {
          showNotification({type: 'error', message: error.response.data.message});
        });
    }
  };

  const formik = useFormik({
    enableReinitialize: false,
    initialValues: initialValues,
    onSubmit,
    validationSchema: validationSchema,
  });

  const goBack = () => {
    navigate(-1)
  };

  const handleDeleteClick = () => () => {
    setConfirmationDeleteModalOpen(true);
  };

  const handleConfirmationDeleteModalClose = () => {
    setConfirmationDeleteModalOpen(false);
  }

  const onConfirmDelete = () => {
    deleteById(serviceOrder.id)
      .then(() => {
        showNotification({type: 'success', message: 'Orden de Servicio eliminada correctamente.'});
        handleConfirmationDeleteModalClose();
        goBack();
      })
      .catch(error => {
        showNotification({type: 'error', message: error.response.data.message});
      });
  };

  const handleCopyClick = () => {
    navigate(`/service-orders/create?copy-from=${id}`, { replace: true });
  };

  const handleChangeStartDate = (value: Moment | null) => {
    formik.setFieldValue('start', moment(value).format('YYYY-MM-DDThh:mm:ss'))
  };

  const fetchServiceOrder = async () => {
    if (copyFrom) {
      formik.resetForm();
      setServiceOrder(initialValues);
      const userResponse = await getById(copyFrom);
      userResponse.data.id = undefined;
      userResponse.data.status = ServiceOrderStatus.IN_PROGRESS;
      userResponse.data.statusHistory = [];
      userResponse.data.allocatedResources.forEach((allocatedResource: { id: any, confirmed: boolean }) => {
        allocatedResource.id = globalThis.crypto?.randomUUID?.() ?? uuidv4();
        allocatedResource.confirmed = false;
      });
      userResponse.data.workScopes.forEach((workScope: { id: any; }) => {
        workScope.id = globalThis.crypto?.randomUUID?.() ?? uuidv4();
      });
      userResponse.data.budgets.forEach((budget: { id: any; }) => {
        budget.id = globalThis.crypto?.randomUUID?.() ?? uuidv4();
      });
      userResponse.data.workContacts.forEach((workContact: { id: any; }) => {
        workContact.id = globalThis.crypto?.randomUUID?.() ?? uuidv4();
        workContact.id = globalThis.crypto?.randomUUID?.() ?? uuidv4();
      });
      setServiceOrder(userResponse.data)
      await formik.setValues(userResponse.data);
      await formik.setFieldValue('start', moment(userResponse.data.start))
      const workers: IUser[] = userResponse.data.allocatedResources
        .map((resource: any) => resource.worker)
        .filter((worker: any): worker is IUser => worker !== null);
      setResources(workers);
    } else {
      if (id) {
        const userResponse = await getById(id);
        setServiceOrder(userResponse.data)
        await formik.setValues(userResponse.data);
        await formik.setFieldValue('start', moment(userResponse.data.start))
        const workers: IUser[] = userResponse.data.allocatedResources
          .map((resource: any) => resource.worker)
          .filter((worker: any): worker is IUser => worker !== null);
        setResources(workers);
      }
    }
  };

  const fetchClients = async () => {
    getActiveClients().then( (response) => {
      setClients(response.data)
    })
  };

  const fetchUsers = async () => {
    getAllActiveByDepartment(Department.OPERATOR).then( (response) => {
      setUsers(response.data)
    })
  };

  const fetchTechniques = async () => {
    const techniquesResponse = await getActiveTechniques();
    setTechniques(techniquesResponse.data);
  };

  const fetchProviders = async () => {
    const providersResponse = await getActiveSubcontractors();
    setProviders(providersResponse.data);
  };

  const isServiceOrderDetailsReadOnly = (status: ServiceOrderStatus | null): boolean => {
    return ![
      ServiceOrderStatus.IN_PROGRESS,
      ServiceOrderStatus.VALIDATE_WORK_SCOPE,
    ].includes(status as ServiceOrderStatus);
  };

  const handleTabChange = (event: SyntheticEvent<Element, Event> | null, value: string | number | null) => {
    let uri = window.location.pathname;
    navigate(uri.substring(0, uri.lastIndexOf('/') + 1) + value);
  };

  useEffect(() => {
    fetchClients();
    fetchTechniques();
    fetchUsers();
    fetchProviders();
  }, []);

  useEffect(() => {
    fetchServiceOrder()
  }, [ id, copyFrom ])

  return (
    <Box
      sx={{
        px: { xs: 2},
        pt: { xs: 'calc(12px + var(--Header-height))' },
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        minWidth: 0,
        height: '100dvh',
        overflow: "auto"
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'start',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              px: { xs: 1 },
              width: '100%',
            }}
          >
            <Breadcrumbs
              size="sm"
              aria-label="breadcrumbs"
              separator={<ChevronRightRoundedIcon/>}
              sx={{ pl: 0 }}
            >
              <Typography level="h4" component="h1">
                <DesignServicesIcon fontSize="small" sx={{ fontSize: 30, marginTop: -1}} />
              </Typography>
              <Typography level="h4" component="h1">
                <Link
                  underline={"none"}
                  onClick={() => goBack()}
                  sx={{ cursor: 'pointer' }}
                >
                  Ordenes de Servicio
                </Link>
              </Typography>
              <Typography level="h4" component="h1">
                {id ? "Editar" : "Nuevo"}
              </Typography>
            </Breadcrumbs>
            <Box>
              <CssVarsProvider>
                <ChipMaterial
                  color={ServiceOrderStatusColors[ServiceOrderStatus[formik.values.status as keyof typeof ServiceOrderStatus]]}
                  label={ServiceOrderStatusNames[ServiceOrderStatus[formik.values.status as keyof typeof ServiceOrderStatus]]}
                  sx={{width: 200, fontWeight: 'bold', fontSize: 15}}
                  icon={<ManageSearchIcon fontSize="medium" sx={{marginTop: -0.5}} />}
                  clickable={true}
                  onClick={() => handleStatusHistoryModalOpen()}
                />
              </CssVarsProvider>
            </Box>
          </Box>

          <ConfirmationModal
            open={confirmationModalOpen}
            onConfirm={(comments?: string) => { onConfirm(comments)}}
            onCancel={handleConfirmationModalClose}
            title={modalTitle}
            message={modalMessage}
            isDeleteAction={false}
            enableComments={true}
          />

          <StatusHistoryModal
            open={statusHistoryModalOpen}
            title={"Historial de la Orden de Servicio"}
            history={serviceOrder.statusHistory}
            onCancel={handleStatusHistoryModalClose}
            historyType={"serviceOrder"}
          />

          <ConfirmationModal
            open={confirmationDeleteModalOpen}
            onConfirm={onConfirmDelete}
            onCancel={handleConfirmationDeleteModalClose}
            title="Confirmacion"
            message="Esta seguro de eliminar esta Orden de Servicio?"
            isDeleteAction={true}
          />

          <Box sx={{ width: '100%', typography: 'body1' }}>


            <Tabs
              value={selectedTab}
              onChange={(_, value) => setSelectedTab(Number(value))}
            >
              <TabList>
                <Tab value={0}>
                  Orden de Servicio
                </Tab>
                <Tab
                  value={1}
                  disabled={![
                    ServiceOrderStatus.UNDER_EVALUATION,
                    ServiceOrderStatus.CLOSED
                  ].includes(serviceOrder.status)}
                >
                  Evaluacion de Desempeño
                </Tab>
              </TabList>
              <TabPanel value={0} sx={{padding: 0}}>
                <form className="form" onSubmit={formik.handleSubmit}>
                  <Grid
                    container
                    rowSpacing={2}
                    columnSpacing={2}
                    marginBlock={1}
                    marginInline={0}
                    sx={{ width: '100%' }}
                  >
                    <Grid xl={6} md={6} sm={6} xs={6}>
                      <CssVarsProvider>
                        <TextField
                          fullWidth
                          id="number"
                          label="Numero Orden de Servicio"
                          name="number"
                          variant="filled"
                          type={"text"}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.number}
                          error={!!(formik.touched.number && formik.errors.number)}
                          slotProps={{
                            inputLabel: {shrink: true},
                            input: {readOnly: isServiceOrderDetailsReadOnly(formik.values.status)}
                          }}
                        />
                        {formik.touched.number && formik.errors.number ? (
                          <span className="Error-alert">{formik.errors.number}</span>
                        ) : null}
                      </CssVarsProvider>
                    </Grid>

                    <Grid xl={6} md={6} sm={6} xs={6}>
                      <CssVarsProvider>
                        <Autocomplete
                          id="client"
                          value={formik.values.client}
                          getOptionLabel={(client) =>
                            `${client.name || ''} - CUIT: ${client.cuit || '...'}`
                          }
                          options={clients}
                          isOptionEqualToValue={(option, value) => option?.id === value?.id}
                          onChange={(e, value) => {
                            formik.setFieldValue('client', value);
                          }}
                          fullWidth
                          readOnly={isServiceOrderDetailsReadOnly(formik.values.status)}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant={"filled"}
                              name="client"
                              label="Cliente"
                              slotProps={{ inputLabel: {shrink: true}}}
                              onBlur={formik.handleBlur}
                              error={!!(formik.touched.client && formik.errors.client)}
                            />
                          )}
                        />
                        {formik.touched.client && formik.errors.client ? (
                          <span className="Error-alert">{String(formik.errors.client)}</span>
                        ) : null}
                      </CssVarsProvider>
                    </Grid>

                    <Grid xl={6} md={6} sm={6} xs={6}>
                      <CssVarsProvider>
                        <TextField
                          fullWidth
                          id="quoteNumber"
                          label="Numero de Cotizacion"
                          name="quoteNumber"
                          variant="filled"
                          type={"text"}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.quoteNumber}
                          error={!!(formik.touched.quoteNumber && formik.errors.quoteNumber)}
                          slotProps={{
                            inputLabel: {shrink: true},
                            input: {readOnly: isServiceOrderDetailsReadOnly(formik.values.status)}
                          }}
                        />
                        {formik.touched.quoteNumber && formik.errors.quoteNumber ? (
                          <span className="Error-alert">{formik.errors.quoteNumber}</span>
                        ) : null}
                      </CssVarsProvider>
                    </Grid>

                    <Grid xl={6} md={6} sm={6} xs={6}>
                      <CssVarsProvider>
                        <TextField
                          fullWidth
                          id="purchaseNumber"
                          label="Numero Orden de Compra"
                          name="purchaseNumber"
                          variant="filled"
                          type={"text"}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.purchaseNumber}
                          error={!!(formik.touched.purchaseNumber && formik.errors.purchaseNumber)}
                          slotProps={{
                            inputLabel: {shrink: true},
                            input: {readOnly: isServiceOrderDetailsReadOnly(formik.values.status)}
                          }}
                        />
                        {formik.touched.purchaseNumber && formik.errors.purchaseNumber ? (
                          <span className="Error-alert">{formik.errors.purchaseNumber}</span>
                        ) : null}
                      </CssVarsProvider>
                    </Grid>

                    <Grid xl={6} md={6} sm={6} xs={6}>
                      <CssVarsProvider>
                        <TextField
                          fullWidth
                          id="workAddress"
                          label="Direccion de Obra"
                          name="workAddress"
                          variant="filled"
                          type={"text"}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.workAddress}
                          error={!!(formik.touched.workAddress && formik.errors.workAddress)}
                          slotProps={{
                            inputLabel: {shrink: true},
                            input: {readOnly: isServiceOrderDetailsReadOnly(formik.values.status)}
                          }}
                        />
                        {formik.touched.workAddress && formik.errors.workAddress ? (
                          <span className="Error-alert">{formik.errors.workAddress}</span>
                        ) : null}
                      </CssVarsProvider>
                    </Grid>

                    <Grid xl={6} md={6} sm={6} xs={6}>
                      <CssVarsProvider>
                        <LocalizationProvider dateAdapter={AdapterMoment}>
                          <DatePicker
                            name="start"
                            label="Fecha de inicio"
                            format="DD/MM/YYYY"
                            value={formik.values.start ? moment(formik.values.start) : null }
                            onChange={handleChangeStartDate}
                            readOnly={isServiceOrderDetailsReadOnly(formik.values.status)}
                            slotProps={{
                              textField: {
                                variant: 'filled',
                                fullWidth: true,
                                onChange: formik.handleChange,
                                onBlur: formik.handleBlur,
                                error: formik.touched.start && Boolean(formik.errors.start),
                                InputLabelProps: {
                                  shrink:  true
                                }
                              }
                            }} />
                        </LocalizationProvider>
                        {formik.touched.start && formik.errors.start ? (
                          <span className="Error-alert">{formik.errors.start}</span>
                        ) : null}
                      </CssVarsProvider>
                    </Grid>

                    <Grid xl={6} md={6} sm={6} xs={6}>
                      <CssVarsProvider>
                        <TextField
                          fullWidth
                          id="allocatedDays"
                          label="Jornadas Asignadas"
                          name="allocatedDays"
                          variant="filled"
                          type={"number"}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.allocatedDays}
                          error={!!(formik.touched.allocatedDays && formik.errors.allocatedDays)}
                          slotProps={{
                            inputLabel: {shrink: true},
                            input: {readOnly: isServiceOrderDetailsReadOnly(formik.values.status)}
                          }}
                        />
                        {formik.touched.allocatedDays && formik.errors.allocatedDays ? (
                          <span className="Error-alert">{formik.errors.allocatedDays}</span>
                        ) : null}
                      </CssVarsProvider>
                    </Grid>

                  </Grid>

                  <Box sx={{ width: '100%', height: 438, typography: 'body1' }} ml={1} mt={2} pr={2}>
                    <Tabs defaultValue={0}>
                      <TabList>
                        <Tab value={0}>Recursos Asignados</Tab>
                        <Tab value={1}>Alcance del Trabajo</Tab>
                        <Tab value={2}>Presupuesto</Tab>
                        <Tab value={3}>Contactos de Obra</Tab>
                        <Tab value={4}>Documentacion Adjunta</Tab>
                      </TabList>
                      <TabPanel value={0} sx={{padding: 0}}>
                        <AllocatedResourcesList
                          serviceOrder={serviceOrder}
                          setServiceOrder={updateServiceOrder}
                          users={users}
                          readOnly={isServiceOrderDetailsReadOnly(formik.values.status)}
                        />
                      </TabPanel>
                      <TabPanel value={1} sx={{padding: 0}}>
                        <WorkScopesList
                          serviceOrder={serviceOrder}
                          setServiceOrder={updateServiceOrder}
                          techniques={techniques}
                          users={resources}
                          readOnly={isServiceOrderDetailsReadOnly(formik.values.status)}
                        />
                      </TabPanel>
                      <TabPanel value={2} sx={{padding: 0}}>
                        <BudgetsList
                          serviceOrder={serviceOrder}
                          setServiceOrder={updateServiceOrder}
                          users={resources}
                          providers={providers}
                          readOnly={isServiceOrderDetailsReadOnly(formik.values.status)}
                        />
                      </TabPanel>
                      <TabPanel value={3} sx={{padding: 0}}>
                        <WorkContactsList
                          serviceOrder={serviceOrder}
                          setServiceOrder={updateServiceOrder}
                          readOnly={isServiceOrderDetailsReadOnly(formik.values.status)}
                        />
                      </TabPanel>
                      <TabPanel value={4} sx={{padding: 0}}>
                        <AttachmentsList
                          serviceOrder={serviceOrder}
                          setServiceOrder={updateServiceOrder}
                          readOnly={formik.values.status === ServiceOrderStatus.CLOSED}
                        />
                      </TabPanel>
                    </Tabs>
                  </Box>

                  <Stack direction="row" justifyContent="space-between" spacing={2} pr={1} pl={1}>

                    <Stack direction="row" justifyContent="flex-start" spacing={2}>
                      {serviceOrder.id && formik.values.status === ServiceOrderStatus.IN_PROGRESS &&
                        <Button
                          onClick={() => handleOpenChangeStatusModal(ServiceOrderStatus.DEFINE_WORK_SCOPE)}
                          variant="solid"
                          color="warning"
                          endDecorator={<EditNoteIcon />}>
                            Definir Alcance de Trabajo
                        </Button>
                      }

                      {serviceOrder.id && formik.values.status === ServiceOrderStatus.VALIDATE_WORK_SCOPE &&
                          <Button
                              onClick={() => handleOpenChangeStatusModal(ServiceOrderStatus.SENT)}
                              variant="solid"
                              color="success"
                              endDecorator={<SendIcon />}>
                              Validar Alcance y Enviar
                          </Button>
                      }

                      {serviceOrder.id && formik.values.status === ServiceOrderStatus.VALIDATE_WORK_SCOPE &&
                        <Button
                          onClick={() => handleOpenChangeStatusModal(ServiceOrderStatus.FIX_WORK_SCOPE)}
                          variant="solid"
                          color="danger"
                          endDecorator={<ErrorOutlineIcon />}>
                          Corregir Alcance de Trabajo
                        </Button>
                      }

                      {serviceOrder.id && formik.values.status === ServiceOrderStatus.IN_PROGRESS &&
                        <Button
                          onClick={handleDeleteClick()}
                          variant="solid"
                          color="danger"
                          endDecorator={<DeleteForeverIcon />}>
                            Eliminar
                        </Button>
                      }
                      {serviceOrder.id && formik.values.status === ServiceOrderStatus.COMPLETED &&
                        <Button
                          onClick={() => handleOpenChangeStatusModal(ServiceOrderStatus.TO_FIX)}
                          variant="solid"
                          color="danger"
                          endDecorator={<ErrorOutlineIcon />}>
                            Corregir Order de Servicio
                        </Button>
                      }
                      {serviceOrder.id && formik.values.status === ServiceOrderStatus.COMPLETED &&
                        <Button
                          onClick={() => handleOpenChangeStatusModal(ServiceOrderStatus.UNDER_EVALUATION)}
                          variant="solid"
                          color="warning"
                          endDecorator={<ErrorOutlineIcon />}>
                          Evaluar Desempeño
                        </Button>
                      }
                      {serviceOrder.id &&
                        <Button
                          onClick={() => handleCopyClick()}
                          variant="solid"
                          endDecorator={<ContentCopyIcon />}>
                            Copiar
                        </Button>
                      }
                    </Stack>

                    <Stack direction="row" justifyContent="flex-end" spacing={2}>
                      <Button onClick={() => goBack()} variant="outlined" endDecorator={<ArrowBackIosNew />}>Volver</Button>
                      {(formik.values.status === ServiceOrderStatus.IN_PROGRESS ||
                        formik.values.status === ServiceOrderStatus.VALIDATE_WORK_SCOPE) &&
                          <Button type="submit" variant="solid" endDecorator={<GridSaveAltIcon />}>Guardar</Button>
                      }
                      {serviceOrder.id && formik.values.status === ServiceOrderStatus.UNDER_EVALUATION &&
                          <Button
                              onClick={() => handleOpenChangeStatusModal(ServiceOrderStatus.CLOSED)}
                              variant="solid"
                              color="success"
                              endDecorator={<CheckCircleOutlineIcon />}
                          >
                              Cerrar Orden de Servicio
                          </Button>
                      }
                    </Stack>
                  </Stack>
                </form>
              </TabPanel>
              <TabPanel value={1} sx={{padding: 0, paddingTop: 1, paddingBottom: 2}}>
                <ServiceOrderEvaluationForm
                  serviceOrder={serviceOrder}
                  isActive={selectedTab === 1}
                  goBack={goBack}
                />
              </TabPanel>
            </Tabs>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default ServiceOrderForm;
